// A free-shipping label charged to the seller after the sale. Orders placed since the seller pays
// the label carry a "line-item/free-shipping-label" line, already inside payoutTotal. Older orders
// that support charged later carry it in transaction metadata instead, so screens that show what a
// seller earned subtract it here. Never both: the line item wins.

export const FREE_SHIPPING_LABEL_CHARGE_KEY = 'freeShippingLabelCharge';
export const LINE_ITEM_FREE_SHIPPING_LABEL = 'line-item/free-shipping-label';

/**
 * The label charge recorded after the sale, in cents, or 0.
 */
export const getLateLabelChargeAmount = transaction => {
  const attributes = transaction?.attributes || {};
  const hasLineItem = (attributes.lineItems || []).some(
    item => item?.code === LINE_ITEM_FREE_SHIPPING_LABEL && !item?.reversal
  );
  const amount = Number(attributes.metadata?.[FREE_SHIPPING_LABEL_CHARGE_KEY]?.amount);
  return !hasLineItem && Number.isFinite(amount) && amount > 0 ? Math.round(amount) : 0;
};

/**
 * What the seller actually earns on the order, in cents.
 */
export const getNetPayoutAmount = transaction => {
  const payout = transaction?.attributes?.payoutTotal?.amount || 0;
  return Math.max(payout - getLateLabelChargeAmount(transaction), 0);
};
